import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { SubscriptionDatablockItemEntity } from './subscription-datablock-item.entity';
import { SubscriptionDatablockListEntity } from './subscription-datablock-list.entity';

@Injectable()
export class DatablockListProvider {
	private readonly datablockList: SubscriptionDatablockListEntity;

	public constructor() {
		this.datablockList = SubscriptionDatablockListEntity.build([
			{
				field: 'label',
				alias: $localize`:i18n=@@subscription.config.datablock.list.column.label:`,
				type: 'string',
				isSearchable: true,
				hasHeaderFilter: true,
				visibleIndex: 0,
			},
			{
				field: 'columnsCount',
				alias: $localize`:i18n=@@subscription.config.datablock.list.column.columns:`,
				type: 'number',
				isSearchable: false,
				visibleIndex: 1,
			},
			{
				field: 'updateDate',
				alias: $localize`:i18n=@@subscription.config.datablock.list.column.lastUpdate:`,
				type: 'datetime',
				format: 'dd-MM-yyyy HH:mm',
				hasHeaderFilter: true,
				isSearchable: true,
				isFilterable: true,
				visibleIndex: 2,
			},
			{
				field: 'updatedByAvatar',
				alias: '',
				type: '',
				hasHeaderFilter: false,
				isSearchable: false,
				isFilterable: false,
				visibleIndex: 3,
			},
		]);
	}

	public getList(): SubscriptionDatablockListEntity {
		return this.datablockList;
	}

	public setListElements(
		elements: Map<string, SubscriptionDatablockItemEntity>
	): SubscriptionDatablockListEntity {
		return this.datablockList.setElements(elements);
	}
}
